<template>
  <span :class="className">{{ tempoFormatadoContador }}</span>
</template>

<script>
import moment from 'moment'

export default {
    name: 'ContadorTempo',
    props: {
        dataReferencia:{
            type: String
        },
        className:{
            type: String,
            default: 'base-timer-label'
        }
    },
    data() {
        return {
            tempoPassado: 0,
        }
    },
    mounted() {
        if(this.dataReferencia){
            this.iniciarTempo()
        }
    },
    computed: {
        tempoFormatadoContador() {
            return this.formatarTempoData(this.tempoPassado)
        },
    },
    methods: {
        iniciarTempo() {
            setInterval(() => (this.tempoPassado += 1), 1000)
        },
        formatarTempoData() {
            const duracao = moment.duration(moment().diff(this.dataReferencia))
            let days    = duracao.days()
            let hours   = duracao.hours()
            let minutes = duracao.minutes()
            let seconds = duracao.seconds()

            if (hours   < 10) {hours   = '0'+hours}
            if (minutes < 10) {minutes = '0'+minutes}
            if (seconds < 10) {seconds = '0'+seconds}

            if(days > 0)
                return `${days}d ${hours}:${minutes}:${seconds}`
            if(hours > 0)
                return `${hours}:${minutes}:${seconds}`
            return `${minutes}:${seconds}`
        },
    }
}
</script>

<style scoped lang="stylus">

.base-timer-label
  font-size 14px
  color white

</style>
